import React from 'react'
import { useHistory } from 'react-router-dom'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined'
import { useAuthentication } from '../../hooks/useAuthentication'
import { Tag } from '../../types'
import { tagListPath } from './tagLinks'
import { tagChipSx } from './tagChipStyle'

type Props = {
  tags?: Tag[]
  /** Called instead of navigating, e.g. to filter the current page in place. */
  onTagClick?: (tag: Tag) => void
}

// Read-only tag chips for table rows; clicking one lists vouchers with it.
const TagChips = ({ tags, onTagClick }: Props) => {
  const history = useHistory()
  const { authState } = useAuthentication()
  if (!tags?.length) return null

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {tags.map((tag) => (
        <Chip
          key={tag.id}
          size="small"
          icon={<LocalOfferOutlinedIcon />}
          label={tag.name}
          clickable
          onClick={(e) => {
            e.stopPropagation()
            if (onTagClick) onTagClick(tag)
            else history.push(tagListPath(tag.id, authState.authUser))
          }}
          sx={{ ...tagChipSx, maxWidth: 180, height: 22, fontSize: '0.75rem' }}
        />
      ))}
    </Box>
  )
}

export default TagChips
